import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import { MenuConstants } from "../../constants";

const initialState = {
  parent: MenuConstants.DASHBOARD,
  child: null,
  action: null,
  isMenuCollapsed: false,
  isSideBarOpen: false,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    changeNavigation: (state, action) => {
      state.parent = action.payload.parent || state.parent || null;
      state.child = action.payload.child || state.child || null;
      state.action = action.payload.action || null;
    },
    resetNavigation: (state) => {
      state.parent = null;
      state.child = null;
      state.action = null;
    },
    toggleMenu: (state) => {
      state.isMenuCollapsed = !state.isMenuCollapsed;
    },
    toggleSideBar: (state) => {
      state.isSideBarOpen = !state.isSideBarOpen;
    },
  },
});

export const { changeNavigation, toggleMenu, resetNavigation, toggleSideBar } =
  navigationSlice.actions;
export default navigationSlice.reducer;
